angular.module('env.customConfig.images', [
    'env.customConfig.provider',
    'env.customConfig.logicResolvers',
    'env.custom.customModule'
])
    .config(function ($customisationConfigProvider, $customLogicResolversProvider) {
        $customisationConfigProvider.images =
            [
                {
                    name: "login-back",
                    options: [
                        {
                            //Default background.
                            //If you want another images based on some criterias, put
                            //them above this option item with a condition to check user.centre (shown below for centre-logo).
                            //If you want just another background for this product installation, change the string below and
                            //that's it.
                            //value: "customise/resources/innovating_future_dental.png"
                            //value: "customise/resources/autodesk-om-background.jpg"
                            value: "customise/resources/ortesi-om-background.jpg"
                        }
                    ]
                },
                {
                    name: "login-logo",
                    options: [
                        {
                            value: "customise/resources/om-logo.png"
                        }
                    ]
                },
                {
                    name: "shell-back",
                    options: [
                        {
                            //Default background.
                            //If you want another images based on some criterias, put
                            //them above this option item with a condition to check user.centre (shown below for centre-logo).
                            //If you want just another background for this product installation, change the string below and
                            //that's it.
                            value: "customise/resources/om-shell-background.png"
                        }
                    ]
                },
                {
                    name: "sidebar-logo",
                    options: [
                        {
                            // value: "customise/resources/exubit-om-logo-sidebar.png"
                        }
                    ]
                },
                {
                    name: "sidebar-logo-small",
                    options: [
                        {
                            // value: "customise/resources/exubit-om-logo-sidebar-small.png"
                        }
                    ]
                },

                {name: "smallReportIcon", options: [{value: "customise/resources/smallreporticon.png"}]},
                {
                    name: "centre-logo",
                    options: [
                        /*{
                            value: "customise/resources/logos/centre1.png",
                            condition: function (context) {
                                return context.user !== null && context.user.centre == 'Centre1';
                            }
                        },*/
                        {
                            //default centre to be shown if none above is true
                            value: "customise/resources/logos/centre-default.png"
                        }
                    ]
                },
                {name: "track", options: [{value: "customise/resources/steps/track.png"}]},
                {name: "workflow", options: [{value: "customise/resources/steps/workflow.png"}]},
                {name: "workflow-light", options: [{value: "customise/resources/steps/workflow-light.png"}]},
                {name: "next", options: [{value: "customise/resources/steps/next.png"}]},
                {name: "in-progress", options: [{value: "customise/resources/steps/wip.png"}]},
                {name: "rejected", options: [{value: "customise/resources/steps/rejected.png"}]},
                {name: "incomplete", options: [{value: "customise/resources/steps/incomplete.png"}]},
                {name: "scrapped", options: [{value: "customise/resources/steps/scrapped.png"}]},
                {name: "design", options: [{value: "customise/resources/steps/design.png"}]},
                {name: "design-exubit", options: [{value: "customise/resources/steps/design2.png"}]},
                {name: "design-review", options: [{value: "customise/resources/steps/design-review.png"}]},
                {name: "qa", options: [{value: "customise/resources/steps/qa.png"}]},
                {name: "approval", options: [{value: "customise/resources/steps/approval.png"}]},
                {name: "approved", options: [{value: "customise/resources/steps/approved.png"}]},
                {name: "on-hold", options: [{value: "customise/resources/steps/hold.png"}]},
                {name: "cancelled", options: [{value: "customise/resources/steps/rejected.png"}]},
                {name: "scan", options: [{value: "customise/resources/steps/scan.png"}]},
                {name: "complete", options: [{value: "customise/resources/steps/complete.png"}]},
                {name: "user-accept", options: [{value: "customise/resources/steps/user-accept.png"}]},
                {name: "shipped", options: [{value: "customise/resources/steps/shipped.png"}]},
                {name: "manufacture", options: [{value: "customise/resources/steps/manufacture.png"}]},
                {name: "toolpath", options: [{value: "customise/resources/steps/manufacture.png"}]},
                {name: "invoice-await", options: [{value: "customise/resources/steps/invoice-await.png"}]},
				{name: "batch-create", options: [{value: "customise/resources/steps/batch-create.png"}]},
                {name: "batch-process", options: [{value: "customise/resources/steps/batch-process.png"}]},
				{name: "print", options: [{value: "customise/resources/steps/print.png"}]},
                {name: "shipping-ready", options: [{value: "customise/resources/steps/shipped.png"}]}

            ];
    })
;
